import parseQuery from './parse-query';
import { find } from './find';
import { addClass } from './helpers';

function setTranslationLanguageClassName() {
    const langSectionElement = find('.js--lang-query');
    let langClassName = 'service--lang-';

    function setDefaultLanguage() {
        langClassName = `${langClassName}eng`;
    }

    function checkQueryStringForLanguage(q) {
        if (q.lang) {
            langClassName = `${langClassName}${q.lang}`;
        } else {
            setDefaultLanguage();
        }
    }

    if (langSectionElement) {
        const query = parseQuery(window.location.search);
        if (query) {
            query.map(checkQueryStringForLanguage);
        } else {
            setDefaultLanguage();
        }
        addClass(langSectionElement, langClassName);
    }
}

module.exports = setTranslationLanguageClassName;



// WEBPACK FOOTER //
// ./src/js/about.js